/**
 * @generated SignedSource<<053fe78d9b2de4c65e67aefefabfdb61>>
 * @relayHash 5584cd26e71b82e189b4c0cb57ad974a
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5584cd26e71b82e189b4c0cb57ad974a

import { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
export type examsNewRoomAnnouncementSubscription$variables = {
  examId: string;
};
export type examsNewRoomAnnouncementSubscription$data = {
  readonly roomAnnouncementWasSent: {
    readonly roomAnnouncement: {
      readonly body: string;
      readonly createdAt: string;
      readonly id: string;
      readonly room: {
        readonly name: string;
      };
    };
    readonly roomAnnouncementsEdge: {
      readonly node: {
        readonly id: string;
      } | null;
    };
  };
};
export type examsNewRoomAnnouncementSubscription = {
  response: examsNewRoomAnnouncementSubscription$data;
  variables: examsNewRoomAnnouncementSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "examId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "examId",
    "variableName": "examId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "body",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "RoomAnnouncementEdge",
  "kind": "LinkedField",
  "name": "roomAnnouncementsEdge",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RoomAnnouncement",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        (v2/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "examsNewRoomAnnouncementSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RoomAnnouncementWasSentPayload",
        "kind": "LinkedField",
        "name": "roomAnnouncementWasSent",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RoomAnnouncement",
            "kind": "LinkedField",
            "name": "roomAnnouncement",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Room",
                "kind": "LinkedField",
                "name": "room",
                "plural": false,
                "selections": [
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "examsNewRoomAnnouncementSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RoomAnnouncementWasSentPayload",
        "kind": "LinkedField",
        "name": "roomAnnouncementWasSent",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RoomAnnouncement",
            "kind": "LinkedField",
            "name": "roomAnnouncement",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Room",
                "kind": "LinkedField",
                "name": "room",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "5584cd26e71b82e189b4c0cb57ad974a",
    "metadata": {},
    "name": "examsNewRoomAnnouncementSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "4e5869d28f7a38e126fd1ba0e5dd8fcd";

export default node;
